<template>
  <div id="qsp">
    <router-link to="/cinestaff">
      <img class="imgicon" src="img/back.png" />
    </router-link>
    <h2>QSP</h2>
    <hr>
    <h3>QSPs à valider</h3>
    <b-pagination
      v-if="qsp.length > 0"
      class="mt-3"
      v-model="currentPageQSP"
      :total-rows="qsp.length"
      :per-page="perPageQSP"
      aria-controls="table-qsp"
      align="fill"
      :limit="15"
      size="sm"
    >
      <template v-slot:page="{ page, active }">
        <span style="color:white;" v-if="active">{{ page }}</span>
        <span v-else>{{ page }}</span>
      </template>
    </b-pagination>
    <b-table
      responsive="sm"
      :items="qsp"
      :fields="fieldsQSP"
      :per-page="perPageQSP"
      :current-page="currentPageQSP"
      class="mt-3"
      id="table-qsp"
      v-if="qsp.length > 0"
      small
      :sort-by.sync="sortByQSP"
      :sort-desc.sync="sortDescQSP"
      sort-icon-left
    >
      <template v-slot:table-colgroup="scope">
        <col v-for="field in scope.fields" :key="field.key" :width="'16.666%'" />
      </template>
      <template v-slot:cell(date)="data">{{utils.toPrettyDate(data.item.date)}}</template>
      <template v-slot:cell(id_site)="data">{{sitesById[data.item.id_site].nom}}</template>
      <template v-slot:cell(id_fonction)="data">{{fonctionsById[data.item.id_fonction].nom}}</template>
      <template
        v-slot:cell(id_employe)="data"
      >{{employesById[data.item.id_employe].nom}} {{employesById[data.item.id_employe].prenom}}</template>

      <template v-slot:cell(seances)="data">
        <seances :item="data.item" />
      </template>
      <template v-slot:cell(remarque)="data">{{data.item.remarque}}</template>
      <template v-slot:cell(valider)="data">
        <a
          href="#"
          @click="valider(data.item, true)"
          class="btn btn-success"
          style="color: white"
          title
        >Valider</a>
        <a
          href="#"
          @click="valider(data.item, false)"
          class="btn btn-danger"
          style="color: white"
          title
        >Refuser</a>
      </template>
    </b-table>
    <p v-else>Rien à signaler...</p>
    <hr>
    <h3>QSP en attente</h3>
    <b-pagination
      v-if="qspAttente.length > 0"
      class="mt-3"
      v-model="currentPageQSPAttente"
      :total-rows="qspAttente.length"
      :per-page="perPageQSPAttente"
      aria-controls="table-qspAttente"
      align="fill"
      :limit="15"
      size="sm"
    >
      <template v-slot:page="{ page, active }">
        <span style="color:white;" v-if="active">{{ page }}</span>
        <span v-else>{{ page }}</span>
      </template>
    </b-pagination>
    <b-table
      responsive="sm"
      :items="qspAttente"
      :fields="fieldsQSPAttente"
      :per-page="perPageQSPAttente"
      :current-page="currentPageQSPAttente"
      class="mt-3"
      id="table-qspAttente"
      v-if="qspAttente.length > 0"
      small
      :sort-by.sync="sortByQSPAttente"
      :sort-desc.sync="sortDescQSPAttente"
      sort-icon-left
    >
      <template v-slot:table-colgroup="scope">
        <col
          v-for="field in scope.fields"
          :key="field.key"
          :width="field.key === 'remarque' || field.key === 'corriger' ? '25%':'14%'"
        />
      </template>
      <template v-slot:cell(date)="data">{{utils.toPrettyDate(data.item.date)}}</template>
      <template v-slot:cell(id_site)="data">{{sitesById[data.item.id_site].nom}}</template>
      <template v-slot:cell(id_fonction)="data">{{fonctionsById[data.item.id_fonction].nom}}</template>
      <template v-slot:cell(sceances)="data">
        <seances :item="data.item" />
      </template>
      <template v-slot:cell(remarque)="data">{{data.item.remarque}}</template>
      <template v-slot:cell(modifier)="data">
        <router-link
          style="color:black"
          :to="`/horaires/modification/${data.item.id}`"
          class="btn btn-warning btn-sm"
        >
          Modifier
          <font-awesome-icon :icon="'pen'" />
        </router-link>
      </template>
    </b-table>
    <p v-else>Rien à signaler...</p>
  </div>
</template>

<script>
import utils from "@/utils";
import api from "@/api";
import Swal from "sweetalert2";
import Seances from "../components/Seances";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000
});

export default {
  data() {
    return {
      utils,
      employesById: [],
      sitesById: [],
      fonctionsById: [],
      qsp: [],
      perPageQSP: 10,
      currentPageQSP: 1,
      sortByQSP: "",
      sortDescQSP: false,
      fieldsQSP: [
        { key: "date", label: "Date", sortable: true },
        { key: "id_site", label: "Site", sortable: true },
        { key: "id_fonction", label: "Fonction", sortable: true },
        { key: "id_employe", label: "Volontaire", sortable: true },
        { key: "seances", label: "Séances", sortable: false },
        { key: "remarque", label: "Remarque", sortable: false },
        { key: "valider", label: "Validation", sortable: false }
      ],
      qspAttente: [],
      perPageQSPAttente: 10,
      currentPageQSPAttente: 1,
      sortByQSPAttente: "",
      sortDescQSPAttente: false,
      fieldsQSPAttente: [
        { key: "date", label: "Date", sortable: true },
        { key: "id_site", label: "Site", sortable: true },
        { key: "id_fonction", label: "Fonction", sortable: true },
        { key: "sceances", label: "Scéances", sortable: false },
        { key: "remarque", label: "Remarque", sortable: false },
        { key: "modifier", label: "Modifier", sortable: false }
      ]
    };
  },
  components: { Seances },
  async created() {
    this.$store.commit("setLoading", true);
    this.employes = (await api.getEmployes()).data.employes;
    for (let employe of this.employes) {
      this.employesById[employe.id] = employe;
    }
    this.sites = (await api.getSites()).data.sites;
    for (let site of this.sites) {
      this.sitesById[site.id] = site;
    }
    this.fonctions = (await api.getFonctions()).data.fonctions;
    for (let fonction of this.fonctions) {
      this.fonctionsById[fonction.id] = fonction;
    }
    this.qsp = (await api.getQSPsValidation()).data.qsp;
    this.qspAttente = (await api.getQSPsProposition()).data.qsp;
    this.$store.commit("setLoading", false);
  },
  methods: {
    async valider(item, ok) {
      let response = await api.validerQSP(item.id, ok);
      if (response.code === 200) {
        this.qsp = (await api.getQSPsValidation()).data.qsp;
      }
      Toast.fire({
        type: response.code === 200 ? "success" : "error",
        text: response.message
      });
      this.$store.dispatch('updateStats');
    }
  }
};
</script>